<template>
  <div id="scroll">
    <div class="container">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <!-- <el-form-item label="插图Id" prop="id">
          <el-input v-model="ruleForm.id" :disabled="isEdit"></el-input>
        </el-form-item> -->
       <el-upload
        class="upload-demo"
        :before-upload="beforeUpload"
        :before-remove="beforeRemove"
        :http-request="upload"
        ref="upload"
        action=""
        :limit="1"
        :on-exceed="overNum"
        :accept="'.jpg,.png,.JPG,'"
      >
        <el-button size="small" type="primary">{{isEdit?'编辑':'上传'}}插图</el-button>
      </el-upload>
        
        <el-form-item label="类型" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择类型">
            <el-option label="公司新闻" value="1"></el-option>
            <el-option label="行业动态" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
      v-model="value1"
      type="datetime"
      placeholder="选择发布日期">
    </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="editWrap">
        <editor-vue
          class="editor"
          :value="ruleForm.content"
          @input="(res) => (ruleForm.content = res)"
        >
        </editor-vue>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addSysNews, editSysNews,uploadIllustration } from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  data() {
    return {
      ruleForm: {
        title: "",
        content: "",
        pictureId: "",
        type: "",
      },
      newFile: new FormData(),
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        id: [{ required: true, message: "请输入插图id", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      val: "",
      value1:'',
      isEdit: false,
      editId: "",
      fileList:[],
    };
  },
  components: {
    editorVue,
  },
  created() {
    this.isEdit = this.$route.params.typeOf == "edit";
    this.editId = this.$route.params.id||'';
    this.ruleForm.title=this.$route.params.title||''
    this.value1=this.$route.params.time||''
    this.ruleForm.pictureId=this.$route.params.pictureId||''
    this.ruleForm.content=this.$route.params.content?decodeURI(this.$route.params.content):''
    this.ruleForm.type=this.$route.params.type?this.$route.params.type+'':''
  },
  methods: {
    async addNew() {
      //确认新增
      this.$refs["ruleForm"].validate(async (valid) => {
        if(valid){
          if (!this.isEdit) {  //新增
          if (this.ruleForm.content.length !== 0) {
            if(this.ruleForm.pictureId==''){
              return this.$message.error('请上传插图！')
            }else if (this.value1==''){
              return this.$message.error('请选择发布日期！')
            }
            //必填项不能为空，否则不能上传
            let param = JSON.parse(JSON.stringify(this.ruleForm));
            for (let k in param) {
              if (k == "content") {
                param[k] = encodeURI(param[k] + "");
              }
            }
            param.createTime=this.value1+''
            console.log("addNew", param);
            let res = await addSysNews(param);
            if (res.code == 200) {
              this.ruleForm.type == 1
                ? this.$message.success("新增公司新闻成功！")
                : this.$message.success("新增行业动态成功！");
              for (let k in this.ruleForm) {
                this.ruleForm[k] = "";
              }
              this.$router.replace("/news");
            }
          } else {
            return this.$message.error('内容不能为空！');
          }
        } else {//编辑状态
          let param = {};
          param.id = this.editId
          param.title = this.ruleForm.title
          param.content = encodeURI(this.ruleForm.content+'')
          param.type=this.ruleForm.type
          param.createTime=new Date(this.value1)+''
          param.pictureId=this.ruleForm.pictureId
          let res = await editSysNews(param);
          if(res.code==200){
            this.$message.success('编辑成功！')
            this.$router.replace("/news");
          }
        }
        }else{
          return false
        }
        
      });
    },
    overNum(files, fileList){
      this.$message.error('插图最多只能上传一张！')
    },
    beforeRemove(files, fileList){
      console.log(this.newFile);
     this.newFile.delete('file')
    },
    beforeUpload(file) {
      //文件上传之前的钩子
      let name = file.name.split('.')
      if (file) {
        let arr=['image/jp2','image/jepg','image/png','image/jpeg']
        let type=name[name.length-1]
        let arr2=['jpg','png']
        console.log('arr2',arr2.includes(type));
        if(arr.includes(file.type)&&arr2.includes(type)){
         this.newFile.append("file", file);
        }else{
          this.$message.error('插图只能上传jpg/png格式文件！')
          return false
        }
      } else {
        return false;
      }
    },
    async upload() {
      //文件上传时的钩子
      let res = await uploadIllustration(this.newFile);
      if (res.code == 200) {
        this.ruleForm.pictureId = res.data.id;
        this.$message.success("插图上传成功！");
      }
    },
    cancel() {
      this.$router.replace('/news')
    },
  },
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form .el-input {
  width: 215px;
}
</style>